import script from "./ElencoCosti.vue?vue&type=script&setup=true&lang=js"
export * from "./ElencoCosti.vue?vue&type=script&setup=true&lang=js"

import "./ElencoCosti.vue?vue&type=style&index=0&id=024149e0&lang=css"

const __exports__ = script;

export default __exports__